// [5.8.2026, 12:53:20] Änderung: Die App-Initialisierung wurde in eine Variable `mountedApp` ausgelagert und um einen globalen Vue-Error-Handler erweitert, der Render-Fehler inklusive betroffener Komponente und Vue-Info in der Konsole protokolliert. Die Plugin-Registrierung und das Mounting laufen anschließend über `mountedApp` weiter.
// [4.8.2026, 16:23:48] Änderung: `main.ts` lädt nun zusätzlich die Rule-Konfiguration über `GetRuleConfig` und übergibt sie an `loadRuleConfig`. Fehler beim Laden der Rule-Konfiguration werden separat protokolliert.
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Vuetify
import "vuetify/styles";
import { initializeApp } from "firebase/app";
import { VueFire } from 'vuefire'
import {connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import {
    getAuth,
    onAuthStateChanged,
    OAuthProvider,
    signInWithRedirect,
} from "firebase/auth";
import {Vuetify3Dialog} from 'vuetify3-dialog';


// Plugins
import { registerPlugins } from "@/plugins";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

const app = createApp(App);

registerPlugins(app);

const firebaseConfig = {
    apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID,
};

const provider = new OAuthProvider('microsoft.com');
provider.setCustomParameters({
  tenant: '494aa4dd-1c7b-453f-88b1-513bbe6982d0'
});

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

import { store, key } from "./store";
import {GetUserData, GetUserDataByAdacount, GetUserDataByEmail, SetUserData} from "@/data/userData";
import {GetEmployData, GetEmployVacationData} from "@/data/employData";
import {GetShiftSetting} from "@/data/shiftSettings";
import {loadSettings, loadRuleConfig} from "@/rules/ruleEngine";
import {GetRuleConfig} from "@/data/ruleConfig";

const environment = import.meta.env.VITE_APP_ENVIRONMENT;
store.commit("SET_ENVIRONMENT", environment)
const firebase_function = import.meta.env.VITE_APP_FUNCTION_FIREBASE;
store.commit("SET_FIREBASE_FUNCTION", firebase_function)

console.log("Environment", location.hostname, firebaseConfig, environment, firebase_function);
if (location.hostname == "localhost") {
    let profile = {
        //userId: "mU9belEzvD2AevHjUTBE",
        userId: "u2B9g47rgBOCEFgt3xSjpqFPcZK2",
        name: "Localhost",
        family_name: "",
        //sub: "mU9belEzvD2AevHjUTBE",
        sub: "u2B9g47rgBOCEFgt3xSjpqFPcZK2",
        isAdmin: true,
    }
    store.commit("SET_USER", profile);

    try{
        GetShiftSetting('170').then((shiftSettings) => {
            console.log(shiftSettings);
            store.commit("SET_USERSETTINGS", shiftSettings)

            loadSettings(shiftSettings).then(() => {
                console.log('Settings loaded');
            }).catch((error) => {
                console.error('Error loading settings:', error);
            });
        });

        GetRuleConfig().then((ruleConfig) => {
            loadRuleConfig(ruleConfig);
        }).catch((error) => {
            console.error('Error loading rule config:', error);
        });
        
        GetEmployData('a002868@itvv.org')?.then((employData) => {
            console.log('employ: ',employData)
            store.commit("SET_EMPLOYDATA", employData)
        });
        
        GetEmployVacationData('010121').then((employVacationData) => {
            store.commit('PUSH_VACATIONDATA', employVacationData);
        });
    }
    catch(e)
    {
        console.error(e);
    }
    
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
}

export const authReady:Promise<void> = new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
        console.log("USER", user)
        if (user) {
            let userData: UserData | null = null;
            try {
                console.info('User by Adacount.')
                userData = await GetUserDataByAdacount(user.email);
//                userData = await GetUserData(user.uid.toString())
            }
            catch(e) {
                try {
                    console.info('User by Email.')
                    userData = await GetUserDataByEmail(user.email);
                    userData.adacount = user.email
                }
                catch(em) {
                    userData = { providerId: user.providerId, 
                        displayName: user.displayName,
                        accessToken: user.accessToken,
                        email: user.email,
                        adacount: user.email,
                        phoneNumber: user.phoneNumber,
                        photoURL: user.photoURL,
                        sub: user.uid  }
                    console.info('User not found in database, creating new user')
                }
            }
            
            let employData = null;
            try {
                employData = await GetEmployData(userData.email);


                console.log(employData);
                
                if(employData) {

                    userData.EmployData = employData;
                    userData.name = employData.firstname
                    userData.family_name = employData.surname
                    userData.emplno = employData.emplno

                    store.commit("SET_EMPLOYDATA", employData)

                    GetEmployVacationData(employData.emplno).then((employVacationData) => {
                        store.commit('PUSH_VACATIONDATA', employVacationData);
                    });
                }
            }
            catch(e) {
                const _name = user.displayName.split(',')
                let name = user.displayName
                let family_name = ''
                if (_name.length >= 2) {
                    name = _name[1]
                    family_name = _name[0]
                }
                
                userData.family_name = family_name
                userData.name = name
/*                userData.EmployData = {
                    cycleid: '',
                    email: user.email,
                    surname: family_name,
                    firstname: name,
                    jobId: '',
                    emplno: '',
                    machineid: '',
                    mean_std_worktime: 0,
                    mean_std_worktime_week: 0
                }*/

                userData.EmployData = {
                    adacount: user.email ? user.email : '',
                    firstname: name ? name : '',
                    surname: family_name,
                    jobId: '',
                    emplno: '',
                    machineid: '',
                    cycleid: '170',
                    email: user.email ? user.email : '',
                    mean_std_worktime: 0,
                    mean_std_worktime_week: 0,
                    vacations: {
                        vacation1: 30,
                        vacation2: 0,
                        vacation3: 0,
                        vacation4: 0,
                    }
                };

                console.info('No EmployData found, loading default vacation values');
                store.commit("SET_EMPLOYDATA", userData.EmployData)
            }
            
            let shiftSettings = null;
            
            // Try to get shift settings from user data
            try{
                if(employData?.shiftSettings)
                {
                    shiftSettings =  employData?.shiftSettings;
                }
                else{
                    shiftSettings = await GetShiftSetting(employData?.cycleid)
                }
            }
            catch(e)
            {
                console.error("No ShiftSettings found in user data");
            }
            
            // If no shift settings found, try to get default settings
            if(shiftSettings === null)
            {
                try{
                    shiftSettings = await GetShiftSetting('170');
                }
                catch(e)
                {
                    console.info("Loaded Default 170 Settings for user");
                }
            }
            
            console.log("ShiftSettings", shiftSettings);
            
            // If still no shift settings found, log error
            if(shiftSettings){
                store.commit("SET_USERSETTINGS", shiftSettings)
            }
            else{
                console.error('No shift settings found');
            }
            
            try{
                userData.lastLogin = new Date()
                store.commit("SET_USER", userData)
                await SetUserData(userData)
            }
            catch (e) {
                console.error('Error setting user data', e)
            }
            
            loadSettings(shiftSettings).then(() => {
                console.log('Settings loaded');
            }).catch((error) => {
                console.error('Error loading settings:', error);
            });
            
            try {
                loadRuleConfig(await GetRuleConfig());
            } catch (error) {
                console.error('Error loading rule config:', error);
            }
            
            resolve();
            
        } else {
            if (location.hostname == "localhost") {
                return;
            }
            
            signInWithRedirect(auth, provider)
        }
    })
})
loadFonts();

const mountedApp = createApp(App);
// Temporär: zeigt bei Render-Fehlern (z.B. v-calendar "dayIndex") die betroffene Komponente.
mountedApp.config.errorHandler = (err, instance, info) => {
    console.error("[GLOBAL-ERROR]", err);
    console.error("[GLOBAL-ERROR] Komponente:", instance?.$options?.name ?? instance?.$?.type?.__name ?? instance);
    console.error("[GLOBAL-ERROR] Vue-Info:", info);
};
mountedApp.use(VueFire, { firebaseApp, modules:[], })
    .use(vuetify).use(Vuetify3Dialog).use(router).use(VCalendar, {}).use(store, key).mount("#app");


